import styled from 'styled-components';

export const PageWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  height: 100%;
`;
